/*
 * WHAT THIS SHOP ASKS FOR UP FRONT.
 *
 * A deposit is a policy of the business, not a fact about a house, so it is
 * remembered the way the letterhead is: set once, and every quote after it
 * opens the same way.
 *
 * THE DEFAULT IS NOTHING. Plenty of shops in this trade take nothing up front,
 * and a form that opens at fifty percent quietly puts a demand on a quote that
 * the person writing it never made - a demand the homeowner then reads as the
 * contractor's terms. The shop that does take half sets it once and never
 * thinks about it again, which is the same amount of work and none of the
 * risk.
 *
 * It lives beside the account, like the letterhead, rather than on any job.
 */

import { currentAccountId } from './account'
import type { DepositMode } from './paper'

export interface DepositPref {
  mode: DepositMode
  value: number
}

export const NO_DEPOSIT: DepositPref = { mode: 'none', value: 0 }

const keyFor = () => `lightsos.deposit.${currentAccountId()}`

export function loadDepositPref(): DepositPref {
  try {
    const raw = localStorage.getItem(keyFor())
    if (!raw) return NO_DEPOSIT
    const saved = JSON.parse(raw) as Partial<DepositPref>
    const mode: DepositMode =
      saved.mode === 'percent' || saved.mode === 'flat' ? saved.mode : 'none'
    const value = Number.isFinite(saved.value) ? Number(saved.value) : 0
    return mode === 'none' ? NO_DEPOSIT : { mode, value: Math.max(0, value) }
  } catch {
    return NO_DEPOSIT
  }
}

export function saveDepositPref(p: DepositPref) {
  try {
    localStorage.setItem(keyFor(), JSON.stringify(p))
  } catch {
    /* private mode: it just does not persist */
  }
}
